/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function Categories(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'Categories',
      'aria-hidden': true,
      focusable: false,
      width:  17 * scale,
      height: 18 * scale,
      viewBox: '0 0 17 18',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('defs', null,createElement('path', {"id":"wf-svg-Categories-__a","d":"m7.5.5 7.5 5v7l-7.5 5-7.5-5v-7z"})),createElement('g', {"transform":"translate(1)","fill":"none","fillRule":"evenodd"},createElement('mask', {"id":"wf-svg-Categories-__b","fill":"#fff"},createElement('use', {"xlinkHref":"#wf-svg-Categories-__a"})),createElement('path', {"d":"m7.5 1.702-8.905 5.936 8.905 8.48 8.905-8.48z","stroke":"currentColor","strokeWidth":"2","mask":"url(#wf-svg-Categories-__b)"}),createElement('path', {"fill":"currentColor","mask":"url(#wf-svg-Categories-__b)","d":"m0 5.5 7.5 5 7.5-5v7l-7.5 5-7.5-5z"})))
}
